import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, updateToCart, removeFromCart } from "../../../services/cart/cartSlice";
import Button from "@mui/material/Button";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Translation from "../../../utils/Translation";
import { getPrice } from "../../../utils/helpers";
import DeleteIcon from "@mui/icons-material/Delete";
import { getValByLang } from "../../../utils/helpers";

const AddToCartButton = ({ product, quantity = 1, setQuantity, type, detail }) => {
  const dispatch = useDispatch();
  const { items, totalPrice } = useSelector((store) => store.cart);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { language } = useSelector((store) => store.global);

  // Find if product is in cart
  const cartItem = items.find((item) => item.id === detail?.id);

  // Add to cart handler
  const handleAddToCart = () => {
    dispatch(
      addToCart({
        product: product,
        product_id: product.id,
        id: detail?.id,
        slug: product.slug,
        detail: detail,
        img: product.img,
        name: product.name,
        price: getPrice(detail),
        quantity: 1,
      })
    );
    if (type === "single_product") {
    setDrawerOpen(true);
    }
    setQuantity && setQuantity(1);
  };

  // Quantity handlers
  const handleIncrease = () => {
    dispatch(
      updateToCart({
        idx: items.findIndex((i) => i.id === detail?.id),
        itemCard: cartItem,
        newVal: 1,
      })
    );
    setQuantity && setQuantity(cartItem.quantity + 1);
  };

  const handleDecrease = () => {
    if (cartItem.quantity === 1) {
      dispatch(removeFromCart(cartItem.id));
      setDrawerOpen(false);
      setQuantity && setQuantity(1);
    } else {
      dispatch(
        updateToCart({
          idx: items.findIndex((i) => i.id === detail?.id),
          itemCard: cartItem,
          newVal: -1,
        })
      );
      setQuantity && setQuantity(cartItem.quantity - 1);
    }
  };

  // Drawer content (mini cart)
  const drawerContent = (
    <Box sx={{ width: 350, p: 3 }}>
      <Typography variant="h6" gutterBottom>
        <Translation data="cart.added_to_cart" />
      </Typography>
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <img src={product.img} alt={product.name} width={60} />
        <Box>
          <Typography>{getValByLang(product.name, language)}</Typography>
          <Typography>
            <Translation data="cart.price" /> {getPrice(detail)}
          </Typography>
        </Box>
      </Box>
      <Typography>
        <Translation data="cart.cart_total" />: {totalPrice?.toFixed(2)}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        className="add-to-cart-button"
        fullWidth
        sx={{ mt: 2 }}
        onClick={() => {
          setDrawerOpen(false);
          window.location.href = "/checkout"; // Or use navigate if using react-router
        }}
      >
        <Translation data="cart.checkout" />
      </Button>
      <Button
        variant="outlined"
        fullWidth
        sx={{ mt: 1 }}
        onClick={() => setDrawerOpen(false)}
      >
        <Translation data="cart.continue_shopping" />
      </Button>
    </Box>
  );

  // Render logic
  if (!cartItem) {
    // Not in cart: show Add to Cart
    return (
      <>
        <Button
          variant="contained"
          startIcon={<ShoppingCartIcon />}
          onClick= { handleAddToCart}
          size="medium"
          display="flex"
          sx={{
            display: "flex",
            width: "50%",
            color: "#fff",
            minHeight: 30,
            boxShadow: 1,
            mb: 1,
          }}
        >
          <Translation data={type == 'single_product' ? 'store.addToCart' : 'store.add'} />
        </Button>
        <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
          {drawerContent}
        </Drawer>
      </>
    );
  } else {
    // In cart: show quantity controls
   return (
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: type === "single_product" ? "50%" : null,
            background: "#0db2ad",
            borderRadius: "10px",
            px: 0,
            py: 0,
            color: "#fff",
            justifyContent: "space-between",
            minHeight: type === "single_product" ? 30 : 20,
            boxShadow: 1,
            mb: 1,
          }}
        >
          <Button
            onClick={handleDecrease}
            sx={{
              minWidth: 0,
              color: "#fff",
              background: "transparent",
              '&:hover': { background: "rgba(255,255,255,0.1)" },
              borderRadius: "50%",
            }}
          >
            {cartItem.quantity > 1 ? <RemoveIcon /> : <DeleteIcon />}
          </Button>
          <Typography
            variant="h6"
            sx={{
              minWidth: 32,
              textAlign: "center",
              color: "#fff",
              fontWeight:  type === "single_product" ? 500 : 400,
              fontSize: 16,
              userSelect: "none",
            }}
          >
            {cartItem.quantity}
          </Typography>
          <Button
            onClick={handleIncrease}
            sx={{
              minWidth: 0,
              color: "#fff",
              background: "transparent",
              '&:hover': { background: "rgba(255,255,255,0.1)" },
              borderRadius: "50%",
            }}
          >
            <AddIcon />
          </Button>
        </Box>
        <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
          {drawerContent}
        </Drawer>
      </>
    );
  }
};

export default AddToCartButton;
// ...existing code...